import { atom } from "recoil";

export const isOpenSettingModal = atom<any>({
  key: "isOpenSettingModal",
  default: false,
});
